import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-psa-field-officer',
  templateUrl: './psa-field-officer.component.html',
  styleUrls: ['./psa-field-officer.component.css']
})
export class PsaFieldOfficerComponent implements OnInit {
  title="Field Details";
  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/pages/functions/psadetails/psa-list/psa-field-officer/psa-field-officer.component.ts